// src/services/api.ts
import { initApi as initApiFn, api as apiFn, setUnauthorizedHandler as setHandlerFn } from '@myorg/vue-api';

export const initApi = initApiFn;
export const setUnauthorizedHandler = setHandlerFn;
export default apiFn;

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// 只做最基礎的 API 初始化，把控制權留給 main.ts
initApi(API_BASE_URL);
